/* eslint-disable import/prefer-default-export */
import { agenticGet, agenticPost } from '../../utils/agenticApiClient';

const normalizeCategories = (payload) => {
  const raw = Array.isArray(payload)
    ? payload
    : payload?.categories || payload?.data || payload?.items || [];

  if (!Array.isArray(raw)) return [];

  const categories = raw
    .map((item, index) => {
      if (typeof item === 'string') {
        const label = item.trim();
        return label ? { categoryId: index + 1, name: label } : null;
      }

      if (!item || typeof item !== 'object') return null;

      const name = String(
        item.name
        || item.displayName
        || item.DisplayName
      ).trim();
      if (!name) return null;

      const rawId = item.categoryId ?? item.CategoryId ?? item.id ?? item.Id;
      const parsedId = Number(rawId);
      const categoryId = Number.isFinite(parsedId) && parsedId > 0 ? parsedId : index + 1;

      return { categoryId, name };
    })
    .filter(Boolean);

  const deduped = [];
  const seen = new Set();

  categories.forEach((item) => {
    const key = `${item.categoryId}:${item.name.toLowerCase()}`;
    if (seen.has(key)) return;
    seen.add(key);
    deduped.push(item);
  });

  return deduped.sort((a, b) => {
    const aId = Number(a?.categoryId);
    const bId = Number(b?.categoryId);

    if (Number.isFinite(aId) && Number.isFinite(bId)) {
      return aId - bId;
    }
    if (Number.isFinite(aId)) return -1;
    if (Number.isFinite(bId)) return 1;
    return String(a?.name || '').localeCompare(String(b?.name || ''));
  });
};

export async function getFeedbackCategories() {
  const response = await agenticGet('/api/feedback/categories');
  return normalizeCategories(response);
}

export async function submitFeedback(payload) {
  return agenticPost('/api/feedback', payload);
}
